module.exports = __webpack_public_path__ + "img/price-tanpatsu.bc9b0fb8.jpg";